var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.75px;}.cls-2{fill:#fffefd;}.cls-3{fill:#e6be8a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "new-inactive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Novos"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 6.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.77,10.93h0a3.57,3.57,0,0,0,0,6.9,3.57,3.57,0,0,0,.08-6.88Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.24,10.71l-.1,0-.14,0a3.71,3.71,0,0,0-.67-.07,3.58,3.58,0,0,0-.87.11,3.7,3.7,0,0,1-.09,7.18h0l.06,0,.14,0a3.84,3.84,0,0,0,.76.08,3.71,3.71,0,0,0,.91-7.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15,
    y: 5,
    width: 1,
    height: 4,
    transform: "translate(31 14) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15,
    y: 20,
    width: 1,
    height: 4,
    transform: "translate(31 44) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.5,
    y: 12.5,
    width: 1,
    height: 4,
    transform: "translate(22.5 6.5) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 22.5,
    y: 12.5,
    width: 1,
    height: 4,
    transform: "translate(37.5 -8.5) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 21.23,
    y: 7.94,
    width: 0.53,
    height: 2.12,
    transform: "translate(30.34 30.57) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 9.73,
    y: 19.44,
    width: 0.53,
    height: 2.12,
    transform: "translate(2.58 42.07) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 9.73,
    y: 7.94,
    width: 0.53,
    height: 2.12,
    transform: "translate(23.44 8.29) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 21.23,
    y: 19.44,
    width: 0.53,
    height: 2.12,
    transform: "translate(51.2 19.79) rotate(135)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewInactive);
export default __webpack_public_path__ + "static/media/new-inactive.cb339745b3bbaa20e7faf2cd82e47975.svg";
export { ForwardRef as ReactComponent };